module.exports = __webpack_public_path__ + "static/media/water-en.cdc6d0e8.svg";